import TENANT_MAPPINGS from './tenantMappingConfig'; 

// "herevr=https://herevr.hu,…": the tenants on a domain of their own. The same value the backend
// gets (app.tenant.custom-origins), written into config.js when the container starts.
// public/index.html repeats this lookup for the hero preload, and the map in nginx.conf for the
// link previews (og/) -- keep the three in step.
const findTenantByCustomOrigin = (host) => {
  const customOrigins = window.RUNTIME_CONFIG?.TENANT_CUSTOM_ORIGINS;
  if (!customOrigins || customOrigins === "__TENANT_CUSTOM_ORIGINS__") return null;

  for (const entry of customOrigins.split(',')) {
    const [tenantId, origin] = entry.split('=').map((part) => part?.trim());
    try {
      if (tenantId && new URL(origin).host === host) return tenantId;
    } catch (error) {
      console.error('Invalid custom origin entry:', entry);
    }
  }
  return null;
};

const extractTenantId = () => {
  const hostname = window.location.hostname;
  const hostnameWithPort = `${hostname}:${window.location.port}`;

  if (hostname.endsWith("dabs.hu") || hostname.endsWith("dabs-uat.duckdns.org")) {
    const domainParts = hostname.split('.');
    if (domainParts.length > 2) {
      return domainParts[0]; 
    }
  }

  // The local dev map is keyed by hostname:port, so it only ever matches a local dev server.
  return findTenantByCustomOrigin(window.location.host) || TENANT_MAPPINGS[hostnameWithPort] || null; 
};

export { extractTenantId };
